import React from 'react'
import { BoxLink as OriginalBoxLink } from '@next-nx/shared-ui/molecules'
import { useTealium } from '@next-nx/hooks'
import { getTimestamp } from '@next-nx/utils'
import { BoxLinkSettings } from './BoxLinkSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { useEditor } from '@craftjs/core'

export const defaultProps = {
  ctaVariant: 'ghost',
  ctaLabel: '',
  link: '',
  pageLink: '',
  openNewTab: false,
}

export const BoxLink = withBlock((props) => {
  const blockProps = {
    ...defaultProps,
    ...props.block,
  }

  const { ctaVariant, ctaLabel, link, pageLink, openNewTab } = blockProps

  const { children } = props

  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }))
  const { linkDataLayer } = useTealium()

  const handleTracking = () => {
    const action_timestamp = getTimestamp()

    linkDataLayer({
      virtual: 'action',
      action_name: 'contattaci',
      action_tech: 'click',
      action_type: 'accedi',
      action_timestamp,
      action_effect: 'accesso_pagina_contatti',
    })
  }

  return (
    <div ref={(ref) => props.retRef(ref)} className={'block-box-link ' + props.className}>
      <OriginalBoxLink
        item={{
          name: children.props.children[0],
          ctaLabel: ctaLabel,
          url: pageLink || link || '#',
          blank: openNewTab,
        }}
        handleTracking={
          (pageLink?.includes('contattaci') || link?.includes('contattaci')) && handleTracking
        }
        ctaVariant={ctaVariant}
        editMode={enabled}
      />
    </div>
  )
}, defaultProps)

BoxLink.craft = withCraft({
  name: 'BoxLink',
  defaultProps: defaultProps,
  settings: BoxLinkSettings,
})
